import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import checkIsMobile from 'shared/utils/checkMobileDevice';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Icon, ToggleButton } from 'shared/components';

import theme from './ToggleAudio.scss';

const propTypes = ({
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  isActive: PropTypes.bool,
  activate: PropTypes.func.isRequired,
  deactivate: PropTypes.func.isRequired,
});

const defaultProps = ({
  isActive: false,
});

class ToggleAudio extends PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  toggle() {
    const { isActive, activate, deactivate } = this.props;
    return isActive ? deactivate() : activate();
  }

  renderActive() {
    return (
      <div>
        <If condition={ !checkIsMobile() }>
          <FormattedMessage
            className={ theme.text }
            id="const.muted"
            defaultMessage="** muted"
          />
          <div className={ theme.spacer } />
        </If>
        <Icon className={ theme.icon } name="mic-mute" />
      </div>
    );
  }

  renderInActive() {
    return (
      <div>
        <Icon className={ theme.icon } name="mic" />
      </div>
    );
  }

  render() {
    const { isActive, activate, deactivate, intl } = this.props;
    // TODO: Wtf?
    const text = !isActive
      ? intl.formatMessage({
        id: 'const.muteAudio',
        defaultMessage: '** Mute Audio',
      })
      : intl.formatMessage({
        id: 'ConversationScreen.TurnOnMicrophoneButton.TitleAttribute',
        defaultMessage: '** Turn on microphone',
      });

    const toggle = () => isActive ? deactivate() : activate();

    return (
      <ToggleButton onChange={ toggle } text={ text } active={ isActive } >
        { isActive ? this.renderActive() : this.renderInActive() }
      </ToggleButton>
    );
  }
}

export default injectIntl(ToggleAudio);
